export default __webpack_public_path__ + "static/media/sms-icon.106d4cf4.svg";